export const contentTypes = [
	{ value: 'text', label: 'Text' },
	{ value: 'simpleChoice', label: 'Simple Choice' },
	{ value: 'cardChoice', label: 'Card Choice' },
	{ value: 'image', label: 'Image' },
	{ value: 'pdf', label: 'PDF' },
	{ value: 'autoComplete', label: 'Autocomplete' },
	{ value: 'cardCarousel', label: 'Card Carousel' },
	{ value: 'adaptiveCard', label: 'Adaptive Card' },
	{ value: 'markdown', label: 'Markdown' },
];
